export const initialState = {
  isLoading: false,
  reported: [],
  telemetry: {},
  deviceStatus: {},
  deviceAction: {}
};
